module.exports = __webpack_public_path__ + "static/media/hotPlate.b81e1555.PNG";